export default __webpack_public_path__ + "static/media/icon-firefox.de11ea4a.png";